import { render, staticRenderFns } from "./AdmEditUpd.vue?vue&type=template&id=e40db136&scoped=true&"
import script from "./AdmEditUpd.vue?vue&type=script&lang=js&"
export * from "./AdmEditUpd.vue?vue&type=script&lang=js&"
import style0 from "./AdmEditUpd.vue?vue&type=style&index=0&id=e40db136&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e40db136",
  null
  
)

export default component.exports